import curry from "../../lib/core/functional/curry";

import { getResults } from "../../transport/voting";

import { emitErrorFactory, clearFeedback, getChoiceId, EVENTS } from "./_common";
import { renderChoice } from "./templates";
import { getVoteRecord } from "./storage";

const renderChoiceFactory = curry(renderChoice);

function renderChoices(postId, container, choices) {
    container.innerHTML = Object.entries(choices).map(renderChoiceFactory(postId)).join("");
}

function prepareResults(listicle, postId) {
    const results = listicle.querySelector(".listicle-item-voting-results");
    const rawChoices = results.dataset.choices;
    try {
        const choices = JSON.parse(unescape(rawChoices));
        renderChoices(postId, results, choices);
    } catch (error) {
        console.log(error);
    }
}

function reactionsReducer(store, [choiceId, { positive }]) {
    store.total += positive.total;
    store.choices[choiceId] = positive.count;
    return store;
}

function displayResult(postId, total, [choiceId, count]) {
    const id = getChoiceId(postId, choiceId);
    const choice = document.getElementById(id);
    if (!choice) {
        return;
    }

    choice.setAttribute("max", total);
    choice.setAttribute("value", count);
    choice.textContent = count;

    const caption = choice
        .closest(".listicle-voting-choice-result")
        .querySelector(".listicle-voting-choice-caption-total");
    caption.textContent = `(${count})`;
}

const displayResultFactory = curry(displayResult);

function highlightSelected(postId, [choiceId, votes]) {
    const id = getChoiceId(postId, choiceId);
    const choice = document.getElementById(id);
    if (!choice) {
        return;
    }

    choice.classList.toggle("listicle-voting-choice-selected", "positive" in votes);
}

const highlightSelectedFactory = curry(highlightSelected);

function onResults(postId, results, { poll, vote }) {
    const { total, choices } = Object.entries(poll.reactions).reduce(reactionsReducer, {
        total: 0,
        choices: {},
    });

    Object.entries(choices).forEach(displayResultFactory(postId, total));

    results.classList.remove("hidden");

    if (vote) {
        Object.entries(vote.reactions).forEach(highlightSelectedFactory(postId));
    }
}

const onResultsFactory = curry(onResults);

function onDisplayEvent(postId, results, event) {
    onResults(postId, results, event.detail);
}

const onDisplayEventFactory = curry(onDisplayEvent);

function voteAgain(listicle, container, _event) {
    container.classList.add("hidden");
    listicle.dispatchEvent(new CustomEvent(EVENTS.VOTE_AGAIN));
}

const voteAgainClickFactory = curry(voteAgain);

export default function prepare({ listicle, context }) {
    const postId = listicle.dataset.postId;
    const results = listicle.querySelector(".listicle-item-voting-results-container");
    const voteAgain = listicle.querySelector(".listicle-item-voting-action-change");

    prepareResults(listicle, postId);

    listicle.addEventListener(EVENTS.DISPLAY_RESULTS, onDisplayEventFactory(postId, results));
    voteAgain.addEventListener("click", voteAgainClickFactory(listicle, results));

    const record = getVoteRecord(listicle);
    if (record) {
        clearFeedback(listicle);
        getResults(window.REBELMOUSE_BOOTSTRAP_DATA.runner.id, postId, record)
            .then(onResultsFactory(postId, results))
            .catch(emitErrorFactory(listicle));
    }
    return { listicle, context };
}
